import anime from 'animejs'

export const NavbarTimeline = {
	ran: false,

	start: function() {
		if (this.ran) return

		anime
			.timeline()
			.add({
				targets: '#Navbar--Logo',
				translateY: [-100, 0],
				easing: 'easeOutExpo',
				delay: 2500,
				duration: 800,
			})
			.add({
				targets: '#App--Navigation > *',
				opacity: [0, 1],
				easing: 'easeOutExpo',
				delay: (el, i) => i * 100,
				duration: 1000,
			})

		this.ran = true
	},
}
